import { logEvent } from 'commons/utils/tracking';
import { MENU_SECONDARY_MARKETPLACES_APPS_CLICK } from 'config/trackingEvents';

export const menuSecondaryMarketplacesAppsClick = () => {
  logEvent(MENU_SECONDARY_MARKETPLACES_APPS_CLICK, {});
};
